<div class="ui container" appMargin appPadding paddingB="30">
  <div class="ui vertical basic segment">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxLayoutAlign="start center"
        fxLayout="row"
        fxLayoutGap="20px"
        (click)="goBack()"
        class="link"
      >
        <div>
          <img src="assets/icons/left-arrow-icon.svg" alt="" />
        </div>
        <div class="equipment-id">
          <!-- Title -->
          <span class="sub-item">Home > Pay NCC > Selected Service </span>
          <h2 class="ui primary header">{{ purpose }}</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
  </div>
  <div *ngIf="success || error || errorayment" appMargin marginY="10px">
    <sui-message class="success" *ngIf="success">
      <div class="header">
        {{ success }}
      </div>
    </sui-message>
    <sui-message class="warning" *ngIf="error" (dismiss)="nullify()">
      <div class="header">
        {{ error | json }}
      </div>
    </sui-message>
    <sui-message class="warning" *ngIf="errorayment">
      <div class="header">
        An RRR({{ paymentDetail?.transactionRef }}) has already been generated
        for this invoice
        <span class="ui primary label link" (click)="goToPayment('UNPAID')"
          >click here to view details</span
        >
      </div>
    </sui-message>
  </div>

  <div *ngIf="paymentInstructions">
    <div [innerHtml]="paymentInstructions"></div>
  </div>
  <div
    fxLayout="row"
    fxLayout.lt-sm="column"
    fxLayoutGap="40px"
    *ngIf="!paymentInstructions"
  >
    <div
      fxFlex="grow"
      class="ui vertical segment"
      [ngClass]="{ loading: pending }"
      *ngIf="!invoiceNotFound"
    >
      <div class="ui equal width form" *ngIf="requireInvoiceNo">
        <div class="field required">
          <label>Invoice Number</label>
          <input
            type="text"
            [formControl]="invoiceNo"
            placeholder="Enter Invoice Number"
          />
        </div>
        <div class="ui right floated buttons">
          <button
            class="ui primary button"
            [disabled]="invoiceNo.invalid"
            (click)="submitInvoice()"
          >
            Submit
          </button>
        </div>
      </div>

      <form
        *ngIf="!requireInvoiceNo"
        class="ui equal width form"
        #f="ngForm"
        (ngSubmit)="submit(f.value, f.valid)"
        novalidate
      >
        <div class="fields" *ngFor="let form of formStructure">
          <ng-template ngFor let-model [ngForOf]="form.structure">
            <div
              class="field"
              [ngClass]="{ required: model.bind.required == true }"
            >
              <label>{{ model.label }}</label>
              <div
                *ngIf="
                  model.name !== 'select_currency' &&
                  model.name !== 'amount_to_pay' &&
                  model.name !== 'company_name' &&
                  model.name !== 'invoice_number' &&
                  model.name !== 'invoice_description' &&
                  model.name !== 'payers_address' &&
                  model.name !== 'confirm_email' &&
                  model.name !== 'payers_email' &&
                  model.name !== 'payers_phone' &&
                  model.name !== 'payers_name' &&
                  model.name !== 'description'
                "
              >
                <input
                  type="text"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  [ngModel]="model.value"
                  (ngModelChange)="model.value = $event"
                  [value]="model.value"
                  ngModel
                />
              </div>
              <div *ngIf="model.name == 'payers_email'">
                <input
                  type="email"
                  pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  [(ngModel)]="payersEmail"
                  autocomplete="off"
                  appBlockCopyPaste
                  (ngModelChange)="model.value = $event"
                  [value]="model.value"
                  #emailAddr="ngModel"
                />
                <small class="text-danger" *ngIf="emailAddr.errors?.pattern"
                  >Email address is invalid</small
                >
              </div>
              <div *ngIf="model.name == 'confirm_email'">
                <input
                  type="email"
                  pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  appBlockCopyPaste
                  [ngModel]="model.value"
                  autocomplete="off"
                  (ngModelChange)="model.value = $event"
                  [value]="model.value"
                  #emailconfirm="ngModel"
                />
                <small class="text-danger" *ngIf="emailconfirm.errors?.pattern"
                  >Email address is invalid</small
                >
              </div>

              <div *ngIf="model.name == 'amount_to_pay'">
                <input
                  type="text"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  myCurrencyFormatter
                  (ngModelChange)="model.value = $event"
                  [attr.disabled]="allowPartPayment == true ? null : 'disabled'"
                  [(ngModel)]="amount"
                  ngModel
                />
              </div>

              <div *ngIf="model.name == 'description'">
                <input
                  type="text"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  (ngModelChange)="model.value = $event"
                  [(ngModel)]="description"
                  ngModel
                />
              </div>

              <div *ngIf="model.name == 'invoice_description'">
                <textarea
                  rows="3"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  (ngModelChange)="model.value = $event"
                  [attr.disabled]="requireInvoice == true ? 'disabled' : null"
                  [(ngModel)]="description"
                  ngModel
                ></textarea>
              </div>

              <div *ngIf="model.name == 'payers_address'">
                <textarea
                  rows="3"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  (ngModelChange)="model.value = $event"
                  [(ngModel)]="payersAddress"
                  ngModel
                ></textarea>
              </div>
              <div *ngIf="model.name == 'payers_phone'">
                <input
                  type="text"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  [(ngModel)]="payersPhone"
                  (ngModelChange)="model.value = $event"
                  ngModel
                />
              </div>

              <div *ngIf="model.name == 'payers_name'">
                <input
                  type="text"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  [(ngModel)]="payersName"
                  (ngModelChange)="model.value = $event"
                  ngModel
                />
              </div>

              <div *ngIf="model.name == 'company_name'">
                <input
                  type="text"
                  [name]="model.name"
                  [attr.disabled]="requireInvoice == true ? 'disabled' : null"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  [ngModel]="companyName"
                  (ngModelChange)="model.value = $event"
                  [value]="companyName"
                  ngModel
                />
              </div>
              <div *ngIf="model.name == 'invoice_number'">
                <input
                  type="text"
                  [name]="model.name"
                  [placeholder]="model.label"
                  [required]="model.bind.required"
                  [ngModel]="invoiceNumber"
                  (ngModelChange)="model.value = $event"
                  disabled
                  [value]="invoiceNumber"
                  ngModel
                />
              </div>
              <!-- <div class="ui pointing red basic label" *ngIf="model.required && formError">
										Required.
												</div> -->
              <div *ngIf="model.name === 'select_currency'">
                <select
                  name="currency_id"
                  (ngModelChange)="model.value = $event"
                  [(ngModel)]="currencyId"
                  [attr.disabled]="requireInvoice == true ? 'disabled' : null"
                  ngModel
                  required="true"
                >
                  <option
                    [attr.name]="model.name"
                    [ngValue]="curr.currencyId"
                    *ngFor="let curr of currency"
                  >
                    {{ curr?.currencyShortName }}
                  </option>
                </select>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="ui tertiary segment" id="light">
          <div>
            By clicking <strong>Proceed</strong> you agree to our
            <u>Terms of Service</u> and <u>Privacy Policy</u> and that your
            continued use of the website is subject to these policies.
          </div>
        </div>
        <div class="ui right floated buttons">
          <!-- <button class="ui button">Reset</button> -->
          <button class="ui primary button" [disabled]="!f.valid">
            Proceed
          </button>
        </div>
      </form>
    </div>

    <div
      fxFlex=" 30%"
      *ngIf="!requireInvoiceNo"
      fxLayout="column"
      fxFlex.lt-sm="100%"
    >
      <div appPadding="7" id="light">
        <div
          appMargin
          marginB="10"
          fxLayout="row"
          *ngIf="getField('description')"
        >
          <div fxFlex="15%">
            <div
              class="ui circular basic small icon label"
              [ngClass]="{ blue: description !== '', red: description == '' }"
            >
              <i
                class="icon"
                style="width: 11px; height: 11px"
                [ngClass]="{
                  'check blue': description !== '',
                  'cancel red': description == ''
                }"
              ></i>
            </div>
          </div>
          <div fxFlex="grow">
            <div class="description">
              <strong>DESCRIPTION</strong>
            </div>

            <div>{{ description }}.</div>
          </div>
        </div>

        <div
          appMargin
          marginB="10"
          fxLayout="row"
          *ngIf="getField('payers_address')"
        >
          <div fxFlex="15%">
            <span
              class="ui circular basic small icon label"
              [ngClass]="{
                blue: payersAddress !== '',
                red: payersAddress == ''
              }"
            >
              <i
                class="icon"
                style="width: 11px; height: 11px"
                [ngClass]="{
                  'check blue': payersAddress !== '',
                  'cancel red': payersAddress == ''
                }"
              ></i>
            </span>
          </div>
          <div fxFlex="grow">
            <div class="description">
              <strong>PAYER’S ADDRESS</strong>
            </div>

            <div>{{ payersAddress }}.</div>
          </div>
        </div>

        <div
          appMargin
          marginB="10"
          fxLayout="row"
          *ngIf="getField('amount_to_pay')"
        >
          <div fxFlex="15%">
            <span
              class="ui circular basic small icon label"
              [ngClass]="{ blue: amount !== 0, red: amount == '' }"
            >
              <i
                class="icon"
                style="width: 11px; height: 11px"
                [ngClass]="{
                  'check blue': amount !== 0,
                  'cancel red': amount == ''
                }"
              ></i>
            </span>
          </div>
          <div fxFlex="grow">
            <div class="description">
              <strong>AMOUNT TO PAY</strong>
            </div>

            <div>{{ getCurr() }} {{ amount }}</div>
          </div>
        </div>

        <div
          appMargin
          marginB="5"
          fxLayout="row"
          *ngIf="getField('payers_name')"
        >
          <div fxFlex="15%">
            <span
              class="ui circular basic small icon label"
              [ngClass]="{ blue: payersName !== '', red: payersName == '' }"
            >
              <i
                class="icon"
                style="width: 11px; height: 11px"
                [ngClass]="{
                  'check blue': payersName !== '',
                  'cancel red': payersName == ''
                }"
              ></i>
            </span>
          </div>
          <div fxFlex="grow">
            <div class="description">
              <strong>PAYER’S Name</strong>
            </div>

            <div>{{ payersName }}.</div>
          </div>
        </div>

        <div
          appMargin
          marginB="5"
          fxLayout="row"
          *ngIf="getField('payers_phone')"
        >
          <div fxFlex="15%">
            <span
              class="ui circular basic small icon label"
              [ngClass]="{ blue: payersPhone !== '', red: payersPhone == '' }"
            >
              <i
                class="icon"
                style="width: 11px; height: 11px"
                [ngClass]="{
                  'check blue': payersPhone !== '',
                  'cancel red': payersPhone == ''
                }"
              ></i>
            </span>
          </div>
          <div fxFlex="grow">
            <div class="description">
              <strong>PAYER’S PHONE</strong>
            </div>

            <div>{{ payersPhone }}.</div>
          </div>
        </div>

        <div
          appMargin
          marginB="5"
          fxLayout="row"
          *ngIf="getField('payers_email')"
        >
          <div fxFlex="15%">
            <span
              class="ui circular basic small icon label"
              [ngClass]="{ blue: payersEmail !== '', red: payersEmail == '' }"
            >
              <i
                class="icon"
                style="width: 11px; height: 11px"
                [ngClass]="{
                  'check blue': payersEmail !== '',
                  'cancel red': payersEmail == ''
                }"
              ></i>
            </span>
          </div>
          <div fxFlex="grow">
            <div class="description">
              <strong>PAYER’S EMAIL</strong>
            </div>

            <div>{{ payersEmail }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
